import React, { useEffect, useMemo, useState } from 'react';
import { DateTime } from 'luxon';
import { DEFAULT_DATE_FORMAT } from '../../constants/dateFormatConstants';
import {
  getEndDate,
  getFocusedField, getMinShownDateString,
  getStartDate,
} from '../../selectors/dateSelectors';
import { areLuxonDatesEqual } from '../../utils/dateUtils';
import CalendarMonth from '../CalendarMonth/CalendarMonth';
import { useDateSelector } from '../../context/dateContext';
import { START_DATE, MONTHS } from '../../constants/dateConstants';

const CalendarHorizontal = () => {
  const minShownDateString = useDateSelector(getMinShownDateString);
  const luxonMinDate = useMemo(() => DateTime.fromFormat(
    minShownDateString,
    DEFAULT_DATE_FORMAT
  ), [minShownDateString]);
  const startDate = useDateSelector(getStartDate);
  const endDate = useDateSelector(getEndDate);
  const focusedField = useDateSelector(getFocusedField);
  const [shownDate, setShownDate] = useState(
    luxonMinDate.startOf('month')
  );
  const updateShownMonth = (months) => {
    setShownDate(shownDate.plus({ months }).startOf('month'));
  };

  useEffect(() => {
    const date = focusedField === START_DATE ? startDate : endDate || startDate;
    if (date) {
      const luxonMinShown = DateTime.fromFormat(minShownDateString, DEFAULT_DATE_FORMAT).startOf('month');
      const luxonDate = DateTime.fromFormat(date, DEFAULT_DATE_FORMAT);
      if (areLuxonDatesEqual(luxonMinShown, shownDate)) {
        setShownDate(luxonDate.startOf('month'));
        return;
      }
      const monthsDiff = shownDate.diff(luxonDate, MONTHS).months;
      if (monthsDiff < -2) {
        setShownDate(luxonDate.plus({ months: -1 }).startOf('month'));
      } else if (monthsDiff > 0) {
        setShownDate(luxonDate.startOf('month'));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Removed shownDate as it bugged previous and next month button
  }, [startDate, endDate, focusedField]);

  const secondShownDate = useMemo(() => shownDate.plus({ months: 1 }), [shownDate]);

  return (
    <div>
      <div className="flex flex-row pad-1 flex-justify-center" data-testid="date-picker-calendar">
        <CalendarMonth
          index={0}
          shownDate={shownDate}
          updateShownMonth={updateShownMonth}
        />
        <div className="margin-2-r" />
        <CalendarMonth
          index={1}
          shownDate={secondShownDate}
          updateShownMonth={updateShownMonth}
        />
      </div>
    </div>
  );
};

export default CalendarHorizontal;
